var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 159,
    viewBox: "0 0 185 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0834 158.783C41.3675 158.783 0.254227 157.637 0.254227 156.224C0.254227 154.811 41.3675 153.666 92.0834 153.666C142.799 153.666 183.913 154.811 183.913 156.224C183.913 157.637 142.799 158.783 92.0834 158.783Z",
    fill: "#093269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5585 153.891H54.0547V0.78125L45.5585 10.6604V153.891Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 117.839H45.6404L53.9761 109.782H45.6404L53.9761 117.839Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 109.579H45.6404L53.9761 101.521H45.6404L53.9761 109.579Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 134.289H45.6404L53.9761 126.231H45.6404L53.9761 134.289Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 126.029H45.6404L53.9761 117.972H45.6404L53.9761 126.029Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 101.319H45.6404L53.9761 93.2617H45.6404L53.9761 101.319Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 93.0591H45.6404L53.9761 85.002H45.6404L53.9761 93.0591Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 84.7994H45.6404L53.9761 76.7422H45.6404L53.9761 84.7994Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 76.5386H45.6404L53.9761 68.4814H45.6404L53.9761 76.5386Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 68.2789H45.6404L53.9761 60.2217H45.6404L53.9761 68.2789Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 60.0181H45.6404L53.9761 51.9609H45.6404L53.9761 60.0181Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 51.7584H45.6404L53.9761 43.7012H45.6404L53.9761 51.7584Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 43.4976H45.6404L53.9761 35.4404H45.6404L53.9761 43.4976Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 35.2378H45.6404L53.9761 27.1807H45.6404L53.9761 35.2378Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 26.9771H45.6404L53.9761 18.9199H45.6404L53.9761 26.9771Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9761 18.7173H45.6404L53.9761 10.6602H45.6404L53.9761 18.7173Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11842 18.94L10.2343 16.3486H39.6027L43.1899 18.94H6.11842Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43884 18.7168H77.1841V20.6048H5.43884V18.7168Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2335 16.3481L54.0547 0.78125L39.6018 16.3481",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0557 0.78125L77.1841 18.7176",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4247 22.7295H57.125V34.0577H39.4247V22.7295Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4247 142.79H57.125V154.118H39.4247V142.79Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1161 25.0898H53.439V28.3939H43.1161V25.0898Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44043 20.6055V40.9585",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74232 47.9062H7.98633V53.8488H2.74232V47.9062Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98633 47.9073L5.36669 40.5723L2.74232 47.9073",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3372 141.346V130.849H106.277V141.356C106.282 144.785 107.447 148.112 109.581 150.796L110.936 152.504H70.6973L72.0567 150.796C74.1831 148.105 75.339 144.775 75.3372 141.346Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.18 148.705H73.4356C74.6781 146.451 75.3278 143.919 75.3237 141.346V130.849H106.278V141.356C106.28 143.927 106.934 146.455 108.18 148.705Z",
    fill: "#D5E6FB"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3367 132.42H106.277V136.857H75.3367V132.42Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0123 40.8838H148.602C151.024 40.8838 152.987 42.847 152.987 45.2687V129.768C152.987 132.189 151.024 134.153 148.602 134.153H33.0123C30.5905 134.153 28.6273 132.189 28.6273 129.768V45.2687C28.6273 42.847 30.5905 40.8838 33.0123 40.8838Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.987 119.657H28.6273V129.768C28.6273 130.931 29.0893 132.046 29.9116 132.868C30.734 133.691 31.8493 134.153 33.0123 134.153H148.579C149.742 134.153 150.857 133.691 151.679 132.868C152.502 132.046 152.964 130.931 152.964 129.768V119.657H152.987Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8854 46.6895H146.732V112.582H34.8854V46.6895Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5171 126.908C88.5161 126.454 88.6499 126.01 88.9014 125.632C89.1529 125.254 89.5108 124.96 89.9299 124.785C90.349 124.611 90.8104 124.565 91.2557 124.653C91.7009 124.741 92.1101 124.959 92.4314 125.28C92.7527 125.6 92.9717 126.009 93.0606 126.454C93.1495 126.899 93.1043 127.361 92.9308 127.78C92.7573 128.2 92.4633 128.558 92.086 128.81C91.7086 129.063 91.2649 129.197 90.811 129.197C90.51 129.198 90.2118 129.139 89.9335 129.024C89.6552 128.91 89.4023 128.741 89.1892 128.528C88.9762 128.316 88.8071 128.063 88.6918 127.785C88.5764 127.507 88.5171 127.209 88.5171 126.908Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6889 152.5H110.923V154.374H70.6889V152.5Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4075 63.2004C53.1117 61.9023 52.1546 60.3057 51.6204 58.551C51.0863 56.7963 50.9914 54.9372 51.3442 53.1372L58.363 60.156C58.7618 60.5526 59.3014 60.7752 59.8639 60.7752C60.4264 60.7752 60.9661 60.5526 61.3649 60.156L67.1989 54.322C67.3966 54.1247 67.5534 53.8904 67.6604 53.6324C67.7674 53.3744 67.8225 53.0979 67.8225 52.8186C67.8225 52.5394 67.7674 52.2628 67.6604 52.0049C67.5534 51.7469 67.3966 51.5126 67.1989 51.3153L60.1849 44.3012C62.1506 43.9174 64.1833 44.068 66.071 44.7376C67.9586 45.4071 69.632 46.5709 70.9165 48.1076C72.201 49.6443 73.0496 51.4975 73.3737 53.474C73.6979 55.4504 73.4856 57.4777 72.7592 59.3441L90.8702 77.0397L92.6166 75.2886L89.7845 72.4565C89.6398 72.3091 89.5587 72.1108 89.5587 71.9043C89.5587 71.6977 89.6398 71.4994 89.7845 71.352L91.9935 69.143C92.1395 68.9975 92.3373 68.9157 92.5434 68.9157C92.7496 68.9157 92.9473 68.9975 93.0933 69.143L94.1978 70.2475L96.5909 67.8592L95.6705 66.9388C95.4756 66.7432 95.3662 66.4785 95.3662 66.2024C95.3662 65.9264 95.4756 65.6616 95.6705 65.4661L115.433 45.7031C115.904 45.2316 116.463 44.8575 117.079 44.6023C117.695 44.347 118.354 44.2156 119.021 44.2156C119.687 44.2156 120.347 44.347 120.962 44.6023C121.578 44.8575 122.137 45.2316 122.608 45.7031L124.628 47.7233C125.1 48.1937 125.474 48.7525 125.729 49.3677C125.984 49.9828 126.115 50.6422 126.115 51.3082C126.115 51.9742 125.984 52.6336 125.729 53.2488C125.474 53.8639 125.1 54.4227 124.628 54.8931L104.865 74.6608C104.67 74.8557 104.405 74.9651 104.129 74.9651C103.853 74.9651 103.588 74.8557 103.393 74.6608L102.472 73.7404L100.084 76.1335L101.184 77.2333C101.256 77.3056 101.314 77.3917 101.353 77.4865C101.393 77.5812 101.413 77.6829 101.413 77.7855C101.413 77.8881 101.393 77.9898 101.353 78.0845C101.314 78.1793 101.256 78.2654 101.184 78.3377L98.9793 80.5467C98.8319 80.6915 98.6336 80.7725 98.427 80.7725C98.2204 80.7725 98.0221 80.6915 97.8748 80.5467L95.0427 77.7147L93.3246 79.4328L108.344 94.0651C110.211 93.3391 112.238 93.1272 114.214 93.4515C116.191 93.7757 118.044 94.6242 119.581 95.9085C121.118 97.1928 122.282 98.8659 122.952 100.753C123.623 102.641 123.774 104.673 123.392 106.639L116.373 99.6253C116.175 99.4277 115.941 99.2708 115.683 99.1638C115.425 99.0568 115.149 99.0018 114.869 99.0018C114.59 99.0018 114.314 99.0568 114.056 99.1638C113.798 99.2708 113.563 99.4277 113.366 99.6253L107.513 105.422C107.315 105.619 107.159 105.853 107.052 106.111C106.945 106.369 106.89 106.646 106.89 106.925C106.89 107.204 106.945 107.481 107.052 107.739C107.159 107.997 107.315 108.231 107.513 108.428L114.527 115.442C112.561 115.826 110.529 115.675 108.641 115.005C106.754 114.335 105.08 113.172 103.796 111.635C102.511 110.099 101.662 108.246 101.337 106.27C101.012 104.294 101.223 102.266 101.948 100.399L86.9289 85.7672L66.4485 106.224C66.7427 106.982 66.8102 107.81 66.6426 108.606C66.475 109.402 66.0795 110.133 65.5044 110.708L60.5625 115.65L54.6341 109.717L59.576 104.78C60.1515 104.205 60.8817 103.809 61.6778 103.642C62.4739 103.474 63.3016 103.541 64.0601 103.836L84.5075 83.3882L66.3777 65.7115C64.3538 66.4989 62.1447 66.6808 60.0194 66.2349C57.8941 65.7891 55.9443 64.7348 54.4075 63.2004Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.195 97.8833L67.6387 63.1954C65.7709 63.923 63.742 64.1355 61.764 63.8109C59.786 63.4862 57.9315 62.6363 56.3943 61.3499C54.8571 60.0635 53.6936 58.3879 53.0254 56.4981C52.3572 54.6083 52.2088 52.5737 52.5958 50.6069L59.6098 57.621C59.8071 57.8187 60.0414 57.9755 60.2994 58.0825C60.5574 58.1895 60.8339 58.2445 61.1132 58.2445C61.3924 58.2445 61.6689 58.1895 61.9269 58.0825C62.1849 57.9755 62.4192 57.8187 62.6165 57.621L68.4505 51.787C68.648 51.5901 68.8048 51.3562 68.9117 51.0986C69.0186 50.841 69.0737 50.5649 69.0737 50.286C69.0737 50.0071 69.0186 49.731 68.9117 49.4734C68.8048 49.2158 68.648 48.9819 68.4505 48.785L61.4365 41.7662C63.4032 41.3829 65.4367 41.5347 67.3247 42.2056C69.2128 42.8766 70.886 44.0421 72.1698 45.5806C73.4536 47.119 74.3008 48.9738 74.623 50.9515C74.9451 52.9291 74.7305 54.957 74.0013 56.8233L109.558 91.5112C111.424 90.7847 113.451 90.5725 115.428 90.8966C117.404 91.2208 119.258 92.0693 120.794 93.3538C122.331 94.6384 123.495 96.3118 124.164 98.1994C124.834 100.087 124.984 102.12 124.601 104.085L117.587 97.0714C117.389 96.8738 117.155 96.7169 116.897 96.61C116.639 96.503 116.362 96.4479 116.083 96.4479C115.804 96.4479 115.527 96.503 115.269 96.61C115.011 96.7169 114.777 96.8738 114.58 97.0714L108.746 102.905C108.548 103.102 108.392 103.336 108.285 103.594C108.178 103.851 108.123 104.128 108.123 104.406C108.123 104.685 108.178 104.961 108.285 105.219C108.392 105.477 108.548 105.711 108.746 105.907L115.774 112.912C113.808 113.295 111.776 113.144 109.888 112.475C108.001 111.805 106.327 110.641 105.043 109.105C103.758 107.569 102.909 105.716 102.584 103.739C102.259 101.763 102.47 99.736 103.195 97.8691V97.8833Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.933 94.2447C106.205 93.9722 106.357 93.603 106.357 93.2181C106.357 92.8332 106.205 92.464 105.933 92.1915L73.9639 61.0909C73.6905 60.8188 73.3206 60.666 72.9349 60.666C72.5492 60.666 72.1792 60.8188 71.9059 61.0909C71.6338 61.3642 71.4811 61.7342 71.4811 62.1198C71.4811 62.5055 71.6338 62.8755 71.9059 63.1488L103.875 94.2447C104.148 94.5168 104.518 94.6696 104.904 94.6696C105.29 94.6696 105.66 94.5168 105.933 94.2447Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4516 70.1747L98.8413 72.5645L64.3605 107.045L61.9708 104.655L96.4516 70.1747Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.887 107.201L61.8154 113.13L66.7574 108.192C67.544 107.406 67.9858 106.338 67.9858 105.226C67.9858 104.113 67.544 103.046 66.7574 102.259C66.3681 101.87 65.906 101.561 65.3974 101.35C64.8888 101.14 64.3437 101.031 63.7932 101.031C63.2426 101.031 62.6975 101.14 62.1889 101.35C61.6803 101.561 61.2182 101.87 60.8289 102.259L55.887 107.201Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6676 63.4635L105.552 69.3477L100.772 74.1271L94.8881 68.2429L99.6676 63.4635Z",
    fill: "#F26531",
    stroke: "#F26531",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.87 45.1683L123.847 43.1458C123.376 42.675 122.817 42.3016 122.202 42.0469C121.587 41.7921 120.928 41.661 120.262 41.661C119.597 41.661 118.937 41.7921 118.322 42.0469C117.707 42.3016 117.149 42.675 116.678 43.1458L96.9125 62.911C96.7177 63.1058 96.6083 63.3699 96.6083 63.6453C96.6083 63.9207 96.7177 64.1848 96.9125 64.3796L104.636 72.1028C104.83 72.2975 105.095 72.4069 105.37 72.4069C105.645 72.4069 105.91 72.2975 106.104 72.1028L125.87 52.3375C126.82 51.3868 127.354 50.0974 127.354 48.7529C127.354 47.4084 126.82 46.119 125.87 45.1683Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3384 66.5933L102.429 74.6837C102.733 74.9878 102.733 75.4809 102.429 75.7851L100.219 77.9946C99.9151 78.2987 99.422 78.2987 99.1179 77.9946L91.0275 69.9042C90.7234 69.6001 90.7234 69.107 91.0275 68.8028L93.237 66.5933C93.5412 66.2892 94.0343 66.2892 94.3384 66.5933Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M103.53 69.1661L105.154 70.7945L124.563 51.3855C124.779 51.1696 124.9 50.8767 124.9 50.5713C124.9 50.2659 124.779 49.9731 124.563 49.7571V49.7571C124.456 49.6496 124.329 49.5644 124.19 49.5061C124.05 49.4479 123.9 49.418 123.749 49.418C123.597 49.418 123.447 49.4479 123.308 49.5061C123.168 49.5644 123.041 49.6496 122.934 49.7571L103.53 69.1661Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100.761 66.3965L102.394 68.025L121.803 48.616C122.019 48.4 122.141 48.1072 122.141 47.8018C122.141 47.4964 122.019 47.2035 121.803 46.9876V46.9876C121.697 46.8801 121.57 46.7948 121.43 46.7366C121.291 46.6784 121.141 46.6484 120.989 46.6484C120.838 46.6484 120.688 46.6784 120.548 46.7366C120.408 46.7948 120.282 46.8801 120.175 46.9876L100.761 66.3965Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9894 63.6251L99.6225 65.2393L119.031 45.8445C119.247 45.6285 119.369 45.3357 119.369 45.0303C119.369 44.7249 119.247 44.4321 119.031 44.2161V44.2161C118.925 44.1086 118.798 44.0233 118.658 43.9651C118.519 43.9069 118.369 43.877 118.217 43.877C118.066 43.877 117.916 43.9069 117.776 43.9651C117.637 44.0233 117.51 44.1086 117.403 44.2161L97.9894 63.6251Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0242 154.952H34.596L44.7583 71.5674H43.1818L33.0242 154.952Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7502 154.952H22.322L32.4844 71.5674H30.9079L20.7502 154.952Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8084 78.4767H43.0759L43.3921 75.9043H31.1199L30.8084 78.4767Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6529 87.9738H41.9204L42.2319 85.4014H29.9644L29.6529 87.9738Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4915 97.4719H40.7637L41.0752 94.8994H28.8077L28.4915 97.4719Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3352 106.973H39.6027L39.9189 104.4H27.6514L27.3352 106.973Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1785 116.47H38.446L38.7622 113.897H26.4947L26.1785 116.47Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.023 125.966H37.2905L37.6021 123.394H25.3346L25.023 125.966Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8668 135.468H36.1343L36.4458 132.896H24.1783L23.8668 135.468Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7053 144.964H34.9775L35.2891 142.392H23.0216L22.7053 144.964Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2642 76.916H41.6593",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8872 77.6709H39.772",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9985 77.6709H33.2642",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M29.867 86.8232H31.9438",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7568 87.2949H36.9424",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9053 96.1641H36.7516",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7183 96.9189H38.4526",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4173 105.504H29.9614",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6006 106.26H31.8486",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9048 134.5H27.7988",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2949 133.793H33.9349",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3875 134.5H31.4556",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1152 143.586H31.8112",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4077 144.413H30.6316",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1821 115.62H37.1201",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6177 115.384H30.5117",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.993 105.094L126.862 107.53L167.521 75.7871L165.647 73.3516L124.993 105.094Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.521 105.094L165.647 107.53L124.993 75.7871L126.862 73.3516L167.521 105.094Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M124.993 140.75L126.149 143.888L167.521 111.443L166.336 108.275L124.993 140.75Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M167.521 140.75L167.238 144.431L124.993 111.443L126.862 109.012L167.521 140.75Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M166.564 73.0166H168.216V154.957H166.564V73.0166Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M124.768 73.0166H126.42V154.957H124.768V73.0166Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M132.949 105.094L134.822 107.53L175.477 75.7871L173.607 73.3516L132.949 105.094Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M175.477 105.094L173.607 107.53L132.949 75.7871L134.822 73.3516L175.477 105.094Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M132.949 140.75L134.11 143.888L175.477 111.443L174.882 108.275L132.949 140.75Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M175.477 140.75L175.193 144.431L132.949 111.443L134.822 109.012L175.477 140.75Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M174.523 73.0166H176.175V154.957H174.523V73.0166Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M132.727 73.0166H134.379V154.957H132.727V73.0166Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M130.597 72.2559H178.298V74.8519H130.597V72.2559Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 72.2559H136.489V74.8519H123.249V72.2559Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M130.597 106.26H178.298V108.856H130.597V106.26Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M123.249 106.26H136.489V108.856H123.249V106.26Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1561 154.952H74.8896L69.91 125.777H66.1717L71.1561 154.952Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6844 154.952H59.9461L64.9305 125.777H68.6641L63.6844 154.952Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1414 154.952H21.875L16.8953 125.777H13.1617L18.1414 154.952Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6697 154.952H6.93142L11.9158 125.777H15.6494L10.6697 154.952Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05392 117.343H79.313V127.241H8.05392V117.343Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3171 117.343H77.5762V127.241H6.3171V117.343Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4097 127.241H70.3632L67.2386 117.343H73.285L76.4097 127.241Z",
    fill: "#093269"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4697 117.343H58.5208L61.6455 127.241H55.5944L52.4697 117.343Z",
    fill: "#093269"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17084 117.343H14.222L17.3467 127.241H11.2955L8.17084 117.343Z",
    fill: "#093269"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9397 117.343H28.9861L32.1108 127.241H26.0644L22.9397 117.343Z",
    fill: "#093269"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7055 117.343H43.7567L46.8813 127.241H40.8302L37.7055 117.343Z",
    fill: "#093269"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70923 121.737H18.5",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91519 123.39H8.7749",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8779 122.979H66.0872",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6748 121.114H62.7782",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.87443adf52342d1fa37e8aaee2e3ee63.svg";
export { ForwardRef as ReactComponent };